import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelCase',
  standalone: true,
})
export class CamelCasePipe implements PipeTransform {
  transform(input: string): string {
    return input.replace(/[^a-zA-Z0-9]+([a-zA-Z0-9])/g, (_, letter) =>
      letter.toUpperCase()
    );
  }
}
